import { render, staticRenderFns } from "./InfoTypeDetailsTree.vue?vue&type=template&id=b70dee22&scoped=true&"
import script from "./InfoTypeDetailsTree.vue?vue&type=script&lang=ts&"
export * from "./InfoTypeDetailsTree.vue?vue&type=script&lang=ts&"
import style0 from "./InfoTypeDetailsTree.vue?vue&type=style&index=0&id=b70dee22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70dee22",
  null
  
)

export default component.exports